import { useCallback, useEffect, useState } from "react";

/** Engine transport mirror: playing flag + playhead, ~15 fps. */
export default function usePlayhead(engine) {
  const [t, setT] = useState({ playing: false, time: 0, duration: 0 });
  useEffect(() => {
    const id = setInterval(() => setT({ playing: engine.playing, time: engine.getPlayhead(), duration: engine.maxDuration || 0 }), 66);
    return () => clearInterval(id);
  }, [engine]);
  const play = useCallback(async () => {
    if (engine.getPlayhead() >= (engine.maxDuration || 0) - 0.05) engine.seekTo(0);
    await engine.play();
  }, [engine]);
  const pause = useCallback(() => engine.pause(), [engine]);
  const stop = useCallback(() => engine.stop(), [engine]);
  const seek = useCallback((s) => engine.seekTo(s), [engine]);
  return { ...t, play, pause, stop, seek };
}
